<template>
	<div v-if="templateData && templateData.post">
		<DetailsViewComponent 
			:templateData="templateData" 
			@refresh="refreshComponentData"
			:currentTabId="currentTabId"
			@currentTabChange="updateCurrentTabId"
			/>
	</div>
</template>


<script>

import DetailsViewComponent from '@vueapp/components/DetailsViewComponent.vue'

export default {
	name: 'DetailsView',
	props: ['postSlug'],
	components: {
		DetailsViewComponent
	},
	data() {
		return {
			templateData: {},
			cookieKey: `currentTabId_${ this.postSlug }`,
			defaultTabId: 'tab-0',
		}
	},
	provide() {
		// if ( this.templateData.post ) {
			return {
				detailsViewId: true,
				linksTarget: this.templateData.links_target
			}
		// }	
	},
	methods: {
		refreshComponentData() {
			const params = new URLSearchParams(window.location.search),
	            eParams = {}
	        params.forEach((value, name) => {
	            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+]+)$/) ) {
	                eParams[name] = value
	            }
	        });

	        let paramsString = ( new URLSearchParams(eParams) ) .toString()

			// console.log(BRYTER.homeUrl + '/data-view/' + this.postSlug + '/?env=' + BRYTER.envId + '&json')
		    fetch( BRYTER.homeUrl + '/details/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
	      		.then(response => response.json())
	      		.then(data => {
	      			// console.log(data)
	        		this.templateData = data
	        		// this.loading = false
	        		this.defaultTabId = data.default_tab
	        		
	      		})
		},

		
		updateCurrentTabId(value) {
			$cookies.set(this.cookieKey, value, 60 * 60 * 12)
		} 
	},
	computed: {
		currentTabId() {
			return $cookies.get( this.cookieKey ) ?? this.defaultTabId
		}
	},
	async beforeMount() {

		this.refreshComponentData()

	},
}	
</script>